<div class=" container mt-3" >
  <div *ngIf="tenderData">

  <div style="text-align: center; color: #333;">

  <h5><u><strong>Online Submitted Tender</strong></u></h5>


    <table style="margin: 0 auto; border-collapse: collapse; text-align: left; width:100%">

      <tr>
        <td style="width:30%"><strong>Organization Name</strong></td>
        <td>{{ tenderData.CategoryName }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Address</strong></td>
        <td>{{tenderData.UserAddress}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>City</strong></td>
        <td>{{tenderData.UserCityName}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Tel No.</strong></td>
        <td>{{tenderData.UserMobile}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Fax No.</strong></td>
        <td>{{tenderData.fax}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Receipt No</strong></td>
        <td>{{tenderData.TenderNo}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Tender No</strong></td>
        <td>{{tenderData.TNo}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>E-pads No</strong></td>
        <td>{{tenderData.invno || 'N/A'}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Description</strong></td>
        <td>
          {{tenderData.description}}
        </td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Remarks</strong></td>
        <td>  {{tenderData.remarks}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Advertisement Date</strong></td>
        <td>{{ tenderData.start_date | date: 'shortDate' || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Closing Date</strong></td>
        <td>{{ tenderData.closing_date | date: 'shortDate' || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Closing Time</strong></td>
        <td>{{ tenderData.closing_time | date: 'shortTime' || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Opening Time</strong></td>
        <td>{{ tenderData.opening_time | date: 'shortTime' || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Tender Documents</strong></td>
        <td>

          <a *ngIf="tenderData?.TenderurlattachmentID!=null" (click)="getAttachmentByGUID(tenderData?.TenderurlattachmentID)" data-toggle="tooltip" title="Download"><i class="fas fa-file-signature fa-fw fa-lg text-info mb-2"></i></a>

        </td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Estimated Cost</strong></td>
        <td>{{ tenderData.TenderFee || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Tender Nature</strong></td>
        <td>{{ tenderData.nature==0?'National':'International'}}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Earnest Money</strong></td>
        <td>{{ tenderData.emoney || 'N/A' }}</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Bid Validity</strong></td>
        <td>{{ tenderData.bvalid || 0 }} Days</td>
      </tr>
      <tr>
        <td style="width:30%"><strong>Bid/Tender Document Cost</strong></td>
        <td>{{ tenderData.bdcost || 'N/A' }}</td>
      </tr>

      <tr>
        <td  colspan="2"><strong>e-bidding documents as per regulations, containing detailed terms and conditions, specifications and requirements etc.
          are available for the registered bidders on EPADS at
          <a href="https://eprocure.gov.pk" target="_blank" rel="noopener noreferrer">www.eprocure.gov.pk</a>.</strong></td>
      </tr>
    </table>
  </div>



  </div>
  <button class="btn btn-secondary mt-3 mb-3" routerLink="/activetenders">Back to Active Tenders</button>
  <br>

</div>
